import React from "react";

const STYLES = {
  HIGH: "text-emerald-300 bg-emerald-400/10 border-emerald-400/20",
  MEDIUM: "text-amber-300 bg-amber-400/10 border-amber-400/20",
  LOW: "text-rose-300 bg-rose-400/10 border-rose-400/20",
  UNKNOWN: "text-zinc-400 bg-zinc-700/30 border-zinc-700/50",
};

export function ConfidenceBadge({ value = "UNKNOWN", className = "" }) {
  const v = (value || "UNKNOWN").toUpperCase();
  const style = STYLES[v] || STYLES.UNKNOWN;
  return (
    <span
      data-testid={`confidence-badge-${v.toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-mono font-medium uppercase tracking-wider border ${style} ${className}`}
    >
      {v}
    </span>
  );
}

export default ConfidenceBadge;
